import { render } from "./QuickPromptMessage.vue?vue&type=template&id=0b64469c&scoped=true"
import script from "./QuickPromptMessage.vue?vue&type=script&lang=js"
export * from "./QuickPromptMessage.vue?vue&type=script&lang=js"

import "./QuickPromptMessage.vue?vue&type=style&index=0&id=0b64469c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b64469c"]])

export default __exports__